import Vue from 'vue';
import SvgSprite from 'vue-svg-sprite';
import VueMatchMedia from '@webqam/vue-match-media';
import VueAxios from 'vue-axios';
// import * as Sentry from '@sentry/vue';
// import { BrowserTracing } from '@sentry/tracing';

import 'swiper/css';
import 'swiper/css/bundle';

import './content';
import './objects/Tooltip/Tooltip.js';
import App from './App.vue';
import router from './router';
import store from './store';
import axios from './helpers/axios';
import titleMixin from './mixins/title';
import breakpoints from './styles/base/_media.scss';
import { USER_REQUEST } from '@/store/actions/user';

import './styles/index.scss';

Vue.mixin(titleMixin);

Vue.use(VueAxios, axios);
Vue.use(SvgSprite);
Vue.use(VueMatchMedia, { breakpoints });

Vue.config.productionTip = false;

/*
if (process.env.VUE_APP_SENTRY_RELEASE) {
  Sentry.init({
    Vue,
    dsn: 'https://0993727cc27c472992705cf5189765ad@o331127.ingest.sentry.io/6662721',
    release: process.env.VUE_APP_SENTRY_RELEASE,

    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router),
        tracingOrigins: ['meine.pflege.de', /^\//],
      }),
    ],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0,
  });
}
*/

store.dispatch(USER_REQUEST).then(() => {
  new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
});
